import { lazy } from 'react';

const UserSessions = lazy(() =>
  import('./sessions/page.js').then((module) => ({ default: module.UserSessions })),
);
const UserInfo = lazy(() => import('./info/page.js').then((module) => ({ default: module.UserInfo })));
const UserSubs = lazy(() => import('./subs/page.js').then((module) => ({ default: module.ManageUsers })));

export { UserInfo, UserSessions, UserSubs };
